import styled, { createGlobalStyle } from 'styled-components';

// The wireframe's Draft Feedback bar (.cmp-bar): its note, then Submit comments at the right
export const FeedbackBarStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 8px;
`;

export const FeedbackNoteStyled = styled.span`
  color: #5b6474;
  font-size: 13px;
`;

// The stacked comments under a changed sentence (.fbc), a reply indented, a not-submitted one dashed
export const ThreadsStyled = styled.div`
  margin: 2px 0 10px 12px;
`;

export const CommentCardStyled = styled.div`
  margin: 4px 0 0 ${({ $reply }) => ($reply ? '18px' : '0')};
  padding: 6px 10px;
  border: 1px ${({ $pending }) => ($pending ? 'dashed' : 'solid')} #d9dee7;
  border-radius: 6px;
  background: ${({ $pending }) => ($pending ? '#fffaf1' : '#f7f9fc')};
  font-size: 13px;

  /* The owner's editor cards: one thin line across the width (who · when, the comment, Resolve at the right) */
  ${({ $inline }) => ($inline ? `
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-top: 2px;
    padding: 2px 8px;
    line-height: 1.4;
  ` : '')}
`;

export const CommentMetaStyled = styled.div`
  color: #5b6474;
  margin-bottom: ${({ $inline }) => ($inline ? '0' : '2px')};
  ${({ $inline }) => ($inline ? 'flex-shrink: 0; white-space: nowrap;' : '')}
`;

// The comment itself in the thin card: takes the space between the name and Resolve
export const CommentTextStyled = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CommentActionStyled = styled.button`
  margin-left: 8px;
  padding: 0;
  white-space: nowrap;
  border: 0;
  background: none;
  color: #1f5fd1;
  cursor: pointer;
  font-size: 12px;

  &:disabled {
    color: #a0a7b4;
    cursor: default;
  }
`;

export const CommentBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 260px;
  margin: 4px 0;

  > div {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }
`;

// The owner's editor: the comments panel above the editor (.ecmt), and the orphan list (.ecmt.orphan)
export const CommentsPanelStyled = styled.div`
  margin: 0 0 8px;
  padding: 8px 12px;
  border: 1px solid #ffd88a;
  border-radius: 6px;
  background: #fffaf1;
  font-size: 13px;
`;

export const CommentsGroupStyled = styled.div`
  margin-top: 6px;

  > q {
    display: block;
    color: #5b6474;
    font-style: italic;
  }
`;

// The commented sentences in the editor (the wireframe's .rb.hl), marked through the CSS Custom Highlight API
export const CommentHighlightStyle = createGlobalStyle`
  ::highlight(jd-draft-comment) {
    background-color: #fff3c4;
  }
`;

// A commented sentence's cards, placed right above it in the editor (the wireframe's .ecmt over its .rb): positioned
// in the editor's scroll area, over the space the sentence's block leaves above itself (DraftCommentsPanel)
export const AnchoredLayerStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 2;
`;

export const AnchoredCardsStyled = styled(CommentsPanelStyled)`
  position: absolute;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  padding: 2px 6px 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

// The cards beside the close (×) at the right
export const AnchoredCardsListStyled = styled.div`
  flex: 1;
  min-width: 0;
`;
